import { gql } from '@apollo/client';

// DD-3696 Find lab: labs that publish their profile to clinics, as a clinic sees them.
export const labDirectoryTemplate = gql`
    query labDirectory(
        $search: SearchString
        $services: [JobName!]
        $sort: SupplierDirectorySort
        $maxDistanceKm: Int
        $hideConnected: Boolean
        $onlyLocated: Boolean
        $limit: Int
        $offset: Int
    ) {
        labDirectory(
            search: $search
            services: $services
            sort: $sort
            maxDistanceKm: $maxDistanceKm
            hideConnected: $hideConnected
            onlyLocated: $onlyLocated
            limit: $limit
            offset: $offset
        ) {
            total
            ownLocationKnown
            labs {
                _id
                name
                organizationNumber
                street
                zip
                city
                phone
                email
                website
                logoSignedUrl
                staffSignedUrl
                geoLocation {
                    latitude
                    longitude
                }
                services
                shortDescription
                description
                openingHours {
                    day
                    time {
                        from
                        to
                    }
                    active
                }
                distanceKm
                connection
            }
        }
    }
`;
